'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var searchInput = require('./search-input-5a163203.js');
var enums$1 = require('./enums-097a7f7b.js');
var useTableContext_hook = require('./useTableContext.hook-ec1eae40.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n"], ["\n  background-color: ", ";\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var TableName = styled__default.p(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  margin: 5px 0;\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  margin: 5px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledSearchInput = styled__default(searchInput.SearchInput)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  width: 328px;\n"], ["\n  width: 328px;\n"])));
var HqOTableHeader = function (_a) {
    var _b = _a.headerType, headerType = _b === void 0 ? enums$1.HeaderStyle.headerWithSearch : _b, _c = _a.searchPlaceholderText, searchPlaceholderText = _c === void 0 ? '' : _c, _d = _a.searchValue, searchValue = _d === void 0 ? '' : _d, _e = _a.tableName, tableName = _e === void 0 ? 'HqO Table' : _e, headerComponent = _a.headerComponent, className = _a.className;
    var tableContext = useTableContext_hook.useTableContext();
    var hasSearchMethodAndCorrectStyle = headerType !== enums$1.HeaderStyle.headerWithoutSearch
        && !!tableContext.methods.onSearch;
    if (headerType === enums$1.HeaderStyle.noHeader) {
        return null;
    }
    return (React__default.createElement(Container, { "data-testid": "hqo-table-header", "data-cy": "hqo-table-header", className: className + "-header" },
        tableName && React__default.createElement(TableName, { className: "hqo-table-name" }, tableName),
        hasSearchMethodAndCorrectStyle
            && (React__default.createElement(StyledSearchInput, { placeholder: searchPlaceholderText, value: searchValue, setValue: tableContext.methods.onSearch, hasIcon: true, hasClearButton: searchValue.length > 0, size: "sm", "data-testid": "hqo-table-header-search" })),
        headerComponent));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.HqOTableHeader = HqOTableHeader;
